import React from "react";

const socials = [
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/farzadcheshk",
    imgSrc: "/images/icon-linkedin.svg",
    alt: "LinkedIn",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/farzad.cheshk",
    imgSrc: "/images/icon-instagram.svg",
    alt: "Instagram",
  },
  {
    name: "YouTube",
    url: "https://www.youtube.com/@FarzadCheshk",
    imgSrc: "/images/icon-youtube.svg",
    alt: "YouTube",
  },
];

function Socials() {
  return (
    <div className="socials-container">
      {socials.map((social, index) => (
        <div key={index} className="social-item">
          <a href={social.url} target="_blank" rel="noreferrer" aria-label={`Follow me on ${social.name}`}>
            <img src={social.imgSrc} alt={social.alt} />
          </a>
        </div>
      ))}
    </div>
  );
}

export default Socials;
